import React from 'react';
import { CtaButton } from '../CtaButton';
import { systems } from '../../data/systems';
export function Systems() {
  return <section className="border-b border-white/10 bg-ink-950" data-id="element-241" data-mp="2zatqt9msa17c">
      <div className="mx-auto w-full max-w-xl px-4 py-12 sm:py-16 lg:max-w-6xl" data-id="element-242" data-mp="342cvx3vr3tao">
        <h2 className="text-center font-display text-[26px] uppercase leading-[1.1] text-white sm:text-3xl lg:text-[40px]" data-id="element-243" data-mp="391y6kbka9q38">
          Ecco esattamente cosa <span className="text-accent" data-id="element-244" data-mp="2cd0bstcj9s62">installerai</span> nella tua attività
        </h2>

        <ul className="mt-9 grid gap-4 lg:grid-cols-3 lg:gap-5" data-id="element-245" data-mp="2gebtmcp6193p">
          {systems.map(system => <li key={system.number} className="flex flex-col rounded-2xl border border-white/10 bg-ink-800 p-5 sm:p-6" data-id="element-246" data-mp="2lbc2evdegpyi">
              <div className="flex items-center justify-between gap-3" data-id="element-247" data-mp="mehzpuk4vui">
                <span className="font-display text-3xl leading-none text-accent sm:text-4xl" data-id="element-248" data-mp="o8r86wguzir">
                  {system.number}
                </span>
                <span className="rounded-md bg-white/5 px-2 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-white/40" data-id="element-249" data-mp="13e3r2sv3jo87">
                  Sistema
                </span>
              </div>

              <h3 className="mt-4 font-display text-lg uppercase leading-tight text-white sm:text-xl" data-id="element-250" data-mp="ucci9f59f1a4">
                {system.title}
              </h3>
              <p className="mt-3 text-[14px] font-semibold leading-snug text-accent-soft sm:text-[15px]" data-id="element-251" data-mp="pgf3vedk44zz">
                {system.lead}
              </p>
              <div className="mt-2 space-y-2" data-id="element-252" data-mp="fn6mk15mrt6z">
                {system.body.map(paragraph => <p key={paragraph} className="text-[14px] leading-relaxed text-white/60 sm:text-[15px]" data-id="element-253" data-mp="bnper12qejyn">
                    {paragraph}
                  </p>)}
              </div>

              <p className="mt-auto pt-5 text-[11px] font-bold uppercase tracking-[0.14em] text-white/35" data-id="element-254" data-mp="3surjvytbfw0z">
                Valore commerciale {system.price}
              </p>
            </li>)}
        </ul>

        <div className="mx-auto mt-9 max-w-md lg:max-w-lg" data-id="element-255" data-mp="3o6rx7bc3sd3z">
          <CtaButton label="Voglio installare questi 6 sistemi" data-id="element-256" data-mp="3o45pnbp7pxlr" />
        </div>
      </div>
    </section>;
}